import { axios } from "@v2/shared/api";

export default {
  getCategories() {
    return axios.get("appeal-categories");
  },
  getTodayExhibitions() {
    return axios.get("exhibitions/today");
  }
};
